import { TextBadge } from '@/components/DesignSystem';
import { useTheme } from '@mui/material';
import React from 'react';

interface PointsRemainingChipProps {
  bgColor?: string,
  text: string,
}

export const PointsRemainingChip = ({
  bgColor,
  text,
}: PointsRemainingChipProps) => {
  const theme = useTheme();
  return (
    <TextBadge
      backgroundColor={bgColor ?? theme.palette.rewardsYellow}
      sx={{
        borderRadius: '2px',
        height: '20px',
        padding: '2px 6px 3px 6px',
        width: 'fit-content',
      }}
      text={text}
      textCategory="body-small"
      textColor={theme.palette.text.primary}
    />
  );
};
